<template>
  <div class="fixed top-0 right-0 bottom-0 left-0 bg-white z2">
    <div class="mx-auto w-app">
      <div class="p1 pt2 relative">
        <a @click="close" class="pointer px2 absolute left-0">
          <back-icon/>
        </a>
        <p class="center m0 truncate px4">
          <slot name="header">New Field Note</slot>
        </p>
      </div>

      <!-- add new resource -->
      <div class="modal-height overflow-auto">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    methods: {
      close () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
  .modal-height {
    /*height: calc(100vh - 43px);*/
    height: calc(var(--vh, 1vh) * 100 - 43px);
  }
  .min-modal-height {
    min-height: calc(var(--vh, 1vh) * 100 - 43px);
  }
</style>
